import pages from '../../routes/pages';

export const isCommandePage = (currentLocation: string) =>
  currentLocation === pages.COMMANDE_PAGE.path;
